import { merchantListService } from "services";

const merchantStatusDdlColumn = () => {
	const loadOptions = async () => {
		try {
			const options = await merchantListService.getStatusList();

			return {
				options,
				hasMore: false,
			};
		} catch {
			return { options: [] };
		}
	};

	return {
		name: "status",
		type: "select" as const,
		loadOptions,
		getOptionLabel: option => option.name,
		getOptionValue: option => option.id,
		placeholder: "Status",
	};
};

export default merchantStatusDdlColumn;
